import { Building2, ClipboardList, Inbox, LayoutDashboard, Route, UserPlus, Users } from 'lucide-react'
import {
  PageToolbar,
  SegmentTabs,
  ToolbarControlsGroup,
  ToolbarIconButton,
} from '@/components/ui/page-toolbar'
import { RefreshCw } from 'lucide-react'
import type { GestoresTab } from '@/hooks/useGestoresPage'

const BASE_TABS = [
  { id: 'clientes' as const, label: 'Clientes', icon: Building2 },
  { id: 'entradas' as const, label: 'Entradas', icon: UserPlus },
  { id: 'equipe' as const, label: 'Equipe PJ', icon: Users },
  { id: 'jornada' as const, label: 'Jornada', icon: Route },
  { id: 'solicitacoes' as const, label: 'Solicitações', icon: ClipboardList },
  { id: 'chamados' as const, label: 'Chamados', icon: Inbox },
] as const

const DASHBOARD_TAB = { id: 'dashboard' as const, label: 'Dashboard', icon: LayoutDashboard }

type Props = {
  tab: GestoresTab
  setTab: (tab: GestoresTab) => void
  loading: boolean
  onReload: () => void
  showDashboard?: boolean
}

export function GestoresTopbar({ tab, setTab, loading, onReload, showDashboard = false }: Props) {
  const tabs = showDashboard ? [DASHBOARD_TAB, ...BASE_TABS] : [...BASE_TABS]

  return (
    <PageToolbar
      navigation={
        <SegmentTabs
          value={tab}
          onChange={(id) => setTab(id as GestoresTab)}
          tabs={tabs.map((t) => ({ id: t.id, label: t.label, icon: t.icon }))}
          ariaLabel='Módulo gestores'
        />
      }
      controls={
        <ToolbarControlsGroup>
          {(tab === 'dashboard' ||
            tab === 'clientes' ||
            tab === 'equipe' ||
            tab === 'chamados' ||
            tab === 'entradas' ||
            tab === 'jornada') && (
            <ToolbarIconButton active={loading} onClick={onReload} title='Atualizar' aria-label='Atualizar'>
              <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
            </ToolbarIconButton>
          )}
        </ToolbarControlsGroup>
      }
    />
  )
}
